import React, { useState } from 'react';
import './Article.css'; // Import corresponding CSS for styling
import A1 from '../../img/A1.jpg';
import A2 from '../../img/A2.jpg';
import A3 from '../../img/A3.jpg';
import A4 from '../../img/A4.jpg';
import A5 from '../../img/A5.jpg';

const articles = [
  {
    date: '10 Jul',
    category: 'Bookings',
    title: 'Navigating the World of Airline Loyalty Programs',
    image: A1,
  },
  {
    date: '12 Jul',
    category: 'Tickets',
    title: 'Navigating the World of Airline Loyalty Programs',
    image: A5,
  },
  {
    date: '18 Jul',
    category: 'Times & Tips',
    title: 'Navigating the World of Airline Loyalty Programs',
    image: A3,
  },
  {
    date: '20 Jul',
    category: 'Deals',
    title: 'Navigating the World of Airline Loyalty Programs',
    image: A2,
  },
  {
    date: '25 Jul',
    category: 'Updates',
    title: 'Navigating the World of Airline Loyalty Programs',
    image: A4,
  },
];

const Article = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? articles.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex === articles.length - 1 ? 0 : prevIndex + 1));
  };

  return (
    <div className="article-container">
      <h2 className="section-title">Latest News & Article</h2>
      <p className="section-subtitle">
        Connecting Needs with Offers for the Professional Flight Services,
      </p>
      <div className="article-slider">
        <button className="slider-btn prev-btn" onClick={handlePrev}>
          ❮
        </button>
        <div
          className="article-cards-wrapper"
          style={{ transform: `translateX(-${currentIndex * (100 / (window.innerWidth < 768 ? 1 : 3))}%)` }} 
        >
          {articles.map((article, index) => {
            const [day, month] = article.date.split(' '); // Split date into day and month
            return (
              <div className="article-card" key={index}>
                <div className="article-image">
                  <img src={article.image} alt={article.title} />
                </div>
                <div className="article-info">
                  <span className="article-date">
                    {day} <br /> {month}
                  </span>
                  <span className="article-category">{article.category}</span>
                  <h3 className="article-title">{article.title}</h3>
                </div>
              </div>
            );
          })}
        </div>
        <button className="slider-btn next-btn" onClick={handleNext}>
          ❯
        </button>
      </div>
      <div className="view-all">
        <button>View All Blogs</button>
      </div>
    </div>
  );
};

export default Article;
